__turbopack_context__.v({
  "app_light_theme": "name-module-scss-module__n41Lzq__app_light_theme",
  "name": "name-module-scss-module__n41Lzq__name",
  "regular": "name-module-scss-module__n41Lzq__regular",
  "unavailable": "name-module-scss-module__n41Lzq__unavailable",
  "wide": "name-module-scss-module__n41Lzq__wide",
  "wideOnMobile": "name-module-scss-module__n41Lzq__wideOnMobile",
});
